module.exports = __webpack_public_path__ + "media/images/countryrect/ki-a765277e7237e8a186969812cbb8bb58.svg";